import { getGatsbyImageData } from 'gatsby-source-sanity';

import VideoLoaderResponsive from 'components/VideoLoaderResponsive';

export default ({ node }) => {
  const sanityConfig = {
    projectId: process.env.GATSBY_SANITY_STUDIO_API_PROJECT_ID || '',
    dataset: process.env.GATSBY_SANITY_STUDIO_API_DATASET || '',
  };

  const imageMobile = getGatsbyImageData(node.thumbnailMobile.asset._ref, { width: 576 }, sanityConfig);

  const imageDesktop = getGatsbyImageData(node.thumbnailDesktop.asset._ref, { width: 822 }, sanityConfig);

  return imageMobile && imageDesktop ? (
    <VideoLoaderResponsive
      urlVideoMobile={node.urlMobile}
      urlVideoDesktop={node.urlDesktop}
      imgThumbnailMobile={imageMobile}
      imgThumbnailDesktop={imageDesktop}
    />
  ) : null;
};
